module.exports = __webpack_public_path__ + "assets/img/w_d_i_7.196df9a1.jpg";